import { render, staticRenderFns } from "./VoiceInput.vue?vue&type=template&id=4ece95cb&scoped=true"
import script from "./VoiceInput.vue?vue&type=script&lang=js"
export * from "./VoiceInput.vue?vue&type=script&lang=js"
import style0 from "./VoiceInput.vue?vue&type=style&index=0&id=4ece95cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece95cb",
  null
  
)

export default component.exports